<template>
  <div class="fill-height">
    <scatter-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :series="getSeries()"
      :xaxis="{
        tickAmount: 10,
        min: 0,
        max: 10
      }"
      :annotations="getAnnotations()"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <v-row
            dense
            align="center"
          >
            <v-col class="text-no-wrap">
              <div class="subtitle-2 grey--text text--grey-100">
                {{ $t('card_title.team_rpe_vs_ttm_acute_load') }}
              </div>
            </v-col>
          </v-row>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </scatter-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.team_rpe_vs_ttm_acute_load') }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="playersTableData"
      >
        <template v-slot:item.name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import ScatterChart from '@/components/charts/ScatterChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'RpeTtmAcuteLoadChart',
  components: { ChartListViewTable, ScatterChart, VisualListToggle },
  props: {
    players: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aggregation: 'AL',
      viewMode: 'chart'
    }
  },
  computed: {
    playersTableData() {
      return this.players.data.map(p => {
        const tgKey = this.getKey('TG')
        const ttmKey = this.getKey('TTM')

        return {
          ...p,
          tg: p.latest_stats?.[tgKey] || 0,
          ttm: p.latest_stats?.[ttmKey] || 0
        }
      })
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.name'),
          value: 'name',
          sortable: true,
          width: '40%'
        },
        {
          text: this.$t('variables.TG'),
          value: 'tg',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.TTM'),
          value: 'ttm',
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    getKey(baseKey) {
      return `${baseKey}_${this.aggregation}`
    },

    getSeries() {
      return this.players.data.map(p => {
        const tgKey = this.getKey('TG')
        const ttmKey = this.getKey('TTM')

        return {
          name: p.last_name + ', ' + p.first_name,
          data: [
            [p.latest_stats?.[tgKey] || 0, p.latest_stats?.[ttmKey] || 0]
          ]
        }
      })
    },

    getMinValue(baseKey) {
      const key = this.getKey(baseKey)
      return this.players.minValues[key] || 0
    },

    getMaxValue(baseKey) {
      const key = this.getKey(baseKey)
      return Math.max(this.players.maxValues[key] || 0, 1)
    },

    getAnnotations() {
      const ttmMin = this.getMinValue('TTM')
      const ttmMax = this.getMaxValue('TTM')
      const ttmMid = (ttmMax - ttmMin) / 2

      return {
        xaxis: [{
          x: 5,
          strokeDashArray: 0,
          borderColor: '#008FFB'
        }],
        yaxis: [{
          y: ttmMid,
          strokeDashArray: 0,
          borderColor: '#008FFB'
        }]
      }
    }
  }
}
</script>
